import './temporaryBadge.css';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React from 'react';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Alert from '@mui/material/Alert';

import { HomeData, TemporaryBadgeData } from '../../api/types';
import { CustomAlert } from '../CustomComponents/CustomComponents';
import { LinkIcon } from '../LinkIcon/LinkIcon';
import { LinkWrapper } from '../LinkWrapper/LinkWrapper';
import { QRWriter } from '../QRWriter/QRWriter';
import { UserDetails } from '../UserDetails/UserDetails';

interface CustomDividerProps {
    color: string;
    border: string;
}

const CustomDivider: React.FC<CustomDividerProps> = ({ color, border }) => (
    <Divider
        sx={{
            height: '10px',
            backgroundColor: color,
            border: `2px solid ${border}`,
            borderRadius: 0,
        }}
    />
);

interface TemporaryBadgeProps {
    accessSituation: boolean;
    badgeData: TemporaryBadgeData;
    noAccessLink: string;
    userData: HomeData;
    userPicture: string;
    translations: Record<string, string>;
}

export const TemporaryBadge: React.FC<TemporaryBadgeProps> = ({
    accessSituation,
    badgeData,
    noAccessLink,
    userData,
    userPicture,
    translations,
}) => (
    <Box>
        <UserDetails
            firstName={userData.firstName}
            lastName={userData.lastName}
            orgUnit={userData.orgUnit}
            userPicture={userPicture}
        />

        {accessSituation ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2rem', marginTop: '2rem' }}>
                <CustomDivider color={badgeData.bandInnerColor} border={badgeData.bandOuterColor} />
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '1rem',
                    }}
                >
                    <QRWriter value={badgeData.tempBadge} />
                    <Typography variant="subtitle1" style={{ lineHeight: 1 }}>
                        {translations.TEMPORARY_BADGE_EXPIRATION_TITLE} {badgeData.endDateTime}
                    </Typography>
                </Box>
                <CustomDivider color={badgeData.bandInnerColor} border={badgeData.bandOuterColor} />
                <Alert icon={false} severity="info">
                    {translations.TEMPORARY_BADGE_TITLE}
                </Alert>
            </Box>
        ) : (
            <Box mt={4}>
                <LinkWrapper to={noAccessLink} translations={translations}>
                    <CustomAlert icon={false} severity="error">
                        <Grid container alignItems="center">
                            <Grid
                                item
                                xs={11}
                                style={{
                                    flexFlow: 'column',
                                }}
                            >
                                <Typography variant="body1" fontWeight={600} color="textPrimary">
                                    {translations.TEMPORARY_BADGE_NO_ACCESS_TITLE} {<LinkIcon link={noAccessLink} />}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    {translations.TEMPORARY_BADGE_NO_ACCESS_SUBTITLE}
                                </Typography>
                            </Grid>
                            <Grid item xs={1} style={{ justifyContent: 'flex-end' }}>
                                <Typography color="textPrimary">
                                    <ChevronRightIcon />
                                </Typography>
                            </Grid>
                        </Grid>
                    </CustomAlert>
                </LinkWrapper>
            </Box>
        )}
    </Box>
);
